import React from 'react';
import { Translate, TranslateHTML } from 'core/translate';
import ConfigAssistantMessage from '../../common/configAssistant/ConfigAssistantMessage';
import { BODY_TYPE, DRIVE_TYPE, ENGINE, TRIM } from './matrixConflictTypes';
import { get, find } from 'lodash';

const getMessageKey = type => {
  return type === TRIM
    ? 'configuration.assistant.not.available.trim'
    : 'configuration.assistant.not.available';
};

const descriptionFields = {
  [BODY_TYPE]: 'bodyTypeDescription',
  [DRIVE_TYPE]: 'driveType',
  [ENGINE]: 'engineDescription',
  [TRIM]: 'trimName'
};

const getMessageDescription = (options, type, id) => {
  const descriptionFieldForType = get(descriptionFields, type);
  const option = find(options, { [type]: id });
  return get(option, descriptionFieldForType);
};

const getPromptKey = (hasSingleDriveOption, hasSingleEngine, hasBodyTypes) => {
  if (hasSingleDriveOption && hasBodyTypes) {
    return 'configuration.assistant.select.config';
  }
  if (hasSingleDriveOption) {
    return 'configuration.assistant.select.trim.and.engine';
  }
  if (hasSingleEngine && !hasBodyTypes) {
    return 'configuration.assistant.select.drive.and.trim';
  }
  return 'configuration.assistant.select.drive.and.config';
};

const MatrixConflictModalMessage = ({
  options,
  hasSingleDriveOption,
  hasBodyTypes,
  hasSingleEngine,
  type,
  id
}) => {
  return (
    <ConfigAssistantMessage
      prompt={
        <Translate
          value={getPromptKey(
            hasSingleDriveOption,
            hasSingleEngine,
            hasBodyTypes
          )}
        />
      }>
      <TranslateHTML
        value={getMessageKey(type)}
        description={getMessageDescription(options, type, id)}
      />
    </ConfigAssistantMessage>
  );
};

export default MatrixConflictModalMessage;
